module.exports = __webpack_public_path__ + "static/media/VP.f3dec04c.webp";